import { formatCurrency } from '@prishapolicy/shared/internationalisation';
import { ProductThemeContext } from '@prishapolicy/shared/ui';
import Image, { StaticImageData } from 'next/image';
import { useContext } from 'react';
import Marquee from 'react-fast-marquee';
import diseaseImages from './disease-images';
type ITicker = {
  lower: number;
  upper: number;
  name: string;
  image: StaticImageData;
};

const row1: ITicker[] = [
  {
    name: 'Colon Cancer',
    lower: 400000,
    upper: 550000,
    image: diseaseImages.colon,
  },
  {
    name: 'Stomach Cancer',
    lower: 400000,
    upper: 500000,
    image: diseaseImages.stomach,
  },
  {
    name: 'Spine Decompression',
    lower: 275000,
    upper: 450000,
    image: diseaseImages.spine,
  },
  {
    name: 'Piles Surgery',
    lower: 8000,
    upper: 130000,
    image: diseaseImages.piles,
  },
  {
    name: 'Brain Tumour',
    lower: 500000,
    upper: 750000,
    image: diseaseImages.brain,
  },
];

const row2: ITicker[] = [
  {
    name: 'Brain Tumour',
    lower: 500000,
    upper: 750000,
    image: diseaseImages.brain,
  },
  {
    name: 'Kidney Stone Removal',
    lower: 100000,
    upper: 240000,
    image: diseaseImages.kidney,
  },
  {
    name: 'Hip Replacement',
    lower: 180000,
    upper: 250000,
    image: diseaseImages.hip,
  },
  {
    name: 'Colonoscopy',
    lower: 9900,
    upper: 26225,
    image: diseaseImages.spine,
  },
  {
    name: 'Knee Replacement',
    lower: 500000,
    upper: 750000,
    image: diseaseImages.knee,
  },
];

const CostCard = (props: ITicker) => {
  const productTheme = useContext(ProductThemeContext);

  return (
    <div
      className={`rounded-medium mx-2 my-2 flex cursor-pointer border bg-white p-5 border-${productTheme?.primaryShade}`}
    >
      <div className="grid place-items-center">
        <Image src={props.image} alt={props.name} width={40} height={40} />
      </div>
      <div className="ml-5 flex flex-1 flex-col justify-between">
        <h3 className="heading-6">{props.name}</h3>
        <p>
          {formatCurrency(props.lower)}-{formatCurrency(props.upper)}
        </p>
      </div>
    </div>
  );
};
const CostsRow = (props: { data: ITicker[] }) => {
  return (
    <>
      {props.data.map((item, idx) => {
        return <CostCard {...item} key={idx} />;
      })}
    </>
  );
};

export const CostsTicker = () => {
  return (
    <div className="pb-16 lg:py-16">
      <div className="container mb-10">
        <h2 className="lg:heading-2 heading-4">The Necessity of Health Insurance</h2>
        <p className="my-4">
          The modern world is an era of medical advancements. Illnesses that were not thought to be curable are slowly
          being treated with revolutionary medical techniques. The quintessential practices for staying healthy—regular
          medical check-ups, full-body tests, vital tracking — everything has progressed in leaps.
        </p>
        <p>
          But all of these have come at a hefty price. Costs of Medical care, surgeries, and treatment for chronic
          ailments have skyrocketed. Below is an overview of the various procedures that can dent anyone's wallet.
        </p>
      </div>
      <Marquee speed={50} gradient={false} pauseOnHover={true}>
        <CostsRow data={row1} />
        <CostsRow data={row1} />
        <CostsRow data={row1} />
      </Marquee>
      <Marquee speed={50} gradient={false} direction="right" pauseOnHover={true}>
        <CostsRow data={row2} />
        <CostsRow data={row2} />
        <CostsRow data={row2} />
      </Marquee>
      <p className="container mt-2 text-start italic lg:text-center">
        Note: The costs above are subject to change. The above representative figures are as of trends witnessed in
        early 2022
      </p>
    </div>
  );
};

export default CostsTicker;
